import { useCallback, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import ModalIconBlock from "../../modal-icon-block";
import { IconTypes, PrintTypes } from "../../../../../enums";
import { Button, Loader, Modal } from "../../../shared";
import { useStore } from "../../../../../hooks";
import { T } from "../../../../../constants";
import TicketResultHeaderJackpot from "../ticket-result-header-jackpot";
import { JackpotTicket } from "../../../../../models/jackpot";
import { BetTicket, Ticket } from "../../../../../models";

interface CheckTicketJackpotProps {}

export const CheckTicketJackpot: React.FC<CheckTicketJackpotProps> = observer(
  () => {
    const {
      ticketsStore,
      jackpotStore,
      modalStore: {
        setCheckModal,
        checkModal: { data, type },
      },
    } = useStore();

    const { jackpotTicket, setJackpotTicket } = jackpotStore;

    const {
      payTicketResponse: { isLoading: payLoading },
    } = ticketsStore;

    useEffect(() => {
      return () => {
        resetTicketData();
        jackpotStore.resetJackpotTicket();
      };
    }, []);

    const resetTicketData = useCallback(() => {
      ticketsStore.resetTicketData();
    }, []);

    const handleClose = useCallback(() => {
      setJackpotTicket(null);
      setCheckModal({ open: false, data: "" });
    }, []);

    const handlePayClick = useCallback(() => {
      if (jackpotTicket?.barcode) {
        ticketsStore.payTicket(
          +jackpotTicket.barcode,
          +jackpotTicket.ticketId,
          PrintTypes.Jackpot,
        );
      }
    }, [jackpotTicket]);

    const openPrintPopup = () => {
      ticketsStore.setTicketPrintData({
        type: PrintTypes.Jackpot,
        data: jackpotTicket,
      });
    };

    return (
      <Modal title={T.CHECK} onClose={handleClose} printTicket={openPrintPopup}>
        <div className="wrapper-pp">
          <ModalIconBlock
            iconName={IconTypes.HandDimond}
            text={
              jackpotTicket?.paidAmount
                ? T.TICKET_IS_PAID
                : T.TICKET_SHOULD_BE_PAID_OUT
            }
            className={"popup-ticket-icon"}
          />
          <TicketResultHeaderJackpot ticket={jackpotTicket as JackpotTicket} />
        </div>

        <div className="pay-ticket-footer">
          {!jackpotTicket?.paidAmount ? (
            <div className="bet-button-block">
              <Button
                onClick={handlePayClick}
                className="pp-button active"
                loading={payLoading}
                text={T.PAY_OUT}
              />
            </div>
          ) : null}
        </div>
      </Modal>
    );
  },
);
